// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oxB6","col":"styles_col__NMd9i"};